import type { Element } from 'react'
import React from 'react'
import styled, { css } from 'styled-components'
import { media } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'

const { shadow } = colors

type Props = {
    front: Element<any>,
    back: Element<any>,
    className?: string,
    recto: boolean,
    minHeight?: number
}

const Flip = (props: Props) => {
    const { front, back, className = '', recto, minHeight = 0 } = props

    const classNames = `${className} ${
        !!window.ActiveXObject || 'ActiveXObject' in window ? 'ie' : ''
    }`

    return (
        <FlipContainer minHeight={minHeight} className={classNames}>
            <Flipper recto={recto} className={classNames}>
                <Front recto={recto} className={classNames}>
                    {front}
                </Front>
                <Back recto={recto} className={classNames}>
                    {back}
                </Back>
            </Flipper>
        </FlipContainer>
    )
}

const FlipContainer = styled.div`
    -webkit-perspective: 1000px;
    -moz-perspective: 1000px;
    perspective: 1000px;
    min-height: ${props => props.minHeight}px;
    transform: ${props => (props.recto ? 'rotateY(180deg)' : '')};

    &.timeline {
        margin-top: 70px;
        height: 67.5vh;
    }
`

const Flipper = styled.div`
    position: relative;
    transition: 0.6s;
    transform-style: preserve-3d;
    transform: ${props => (props.recto ? '' : 'rotateY(180deg)')};

    &.ie {
        transform: ${props => (props.recto ? '' : 'rotateY(0deg)')};
    }
`

const styledFlip = css`
    backface-visibility: hidden;
    top: 0;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    border-radius: 10px;
    position: absolute;
    box-shadow: 0 0 20px 0 ${shadow};
    &.ie {
        transform: ${props => (props.recto ? '' : 'rotateY(0deg)')};
    }

    &.coupon {
        box-shadow: none;
    }

    &.card {
        overflow: hidden;
        max-height: calc((100vw - 40px) * 0.638);
        ${media.medium`
            height: auto;
        `};
    }
`

const Back = styled.div`
    ${styledFlip};
    transform: rotateY(180deg);

    &.card {
        border-radius: 7%;
        display: grid;
    }

    &.card,
    &.coupon {
        position: ${props => (props.recto ? 'absolute' : 'relative')};
        ${media.medium`
            position: relative;
        `};
    }
`

const Front = styled.div`
    ${styledFlip};
    transform: rotateY(0deg);
    z-index: 2;

    &.ie {
        opacity: ${props => (props.recto ? '1' : '0')};
        transition: opacity 0.5s linear;
    }

    &.card {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background-color: white;
    }

    &.card,
    &.coupon {
        position: ${props => (props.recto ? 'relative' : 'absolute')};
        ${media.medium`
            position: absolute;
        `};
    }
`

export { Flip }
